// General variables
export const contentElementId = 'app-content'

export const appConfig = {
  contentElementId
}
